import { ScheduleListItem } from '@occc-app/lib/util-location-schedule';

export const getTimeSchedule = (day: ScheduleListItem): string => {
  if (!day.open) {
    return 'Closed';
  }

  if (day.open.is24h) {
    return '24 Hours';
  }

  return `${day.open?.opensTitle} - ${day.open?.closesTitle}`;
};
